import NestedAccordionBlock from 'components/blocks/Accordion/NestedAccordion';
import { AccordionActionCardsBlock } from 'components/blocks/ActionCards';
import ReferencedEmailFormBlock from 'components/blocks/ReferencedEmailForm';
import { AccordionRichTextBlock } from 'components/blocks/RichText';
import { AccordionSplitInfoCardBlock } from 'components/blocks/SplitInfoCard';
import { m, mapBlocksInternal, MappingEntry } from './mappingUtils';

const ACCORDION_MAPPING: MappingEntry[] = [
  m('action_cards', AccordionActionCardsBlock),
  m('split_info_card', AccordionSplitInfoCardBlock),
  m('rich_text', AccordionRichTextBlock),
  m('nested_accordion', NestedAccordionBlock),
  m('referenced_email_form', ReferencedEmailFormBlock),
];

const mapAccordionBlocks = mapBlocksInternal(ACCORDION_MAPPING);
export default mapAccordionBlocks;
